/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IntegrationConnectionDtoFromJSON, IntegrationConnectionDtoToJSON, } from './IntegrationConnectionDto.js';
import { IntegrationVisibilityFromJSON, IntegrationVisibilityToJSON, } from './IntegrationVisibility.js';
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the IntegrationDto interface.
 */
export function instanceOfIntegrationDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('websiteUrl' in value) || value['websiteUrl'] === undefined)
        return false;
    if (!('iconSvgPath' in value) || value['iconSvgPath'] === undefined)
        return false;
    if (!('visibility' in value) || value['visibility'] === undefined)
        return false;
    return true;
}
export function IntegrationDtoFromJSON(json) {
    return IntegrationDtoFromJSONTyped(json, false);
}
export function IntegrationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': IntegrationTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'],
        'websiteUrl': json['websiteUrl'],
        'iconSvgPath': json['iconSvgPath'],
        'visibility': IntegrationVisibilityFromJSON(json['visibility']),
        'connection': json['connection'] == null ? undefined : IntegrationConnectionDtoFromJSON(json['connection']),
    };
}
export function IntegrationDtoToJSON(json) {
    return IntegrationDtoToJSONTyped(json, false);
}
export function IntegrationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': IntegrationTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'websiteUrl': value['websiteUrl'],
        'iconSvgPath': value['iconSvgPath'],
        'visibility': IntegrationVisibilityToJSON(value['visibility']),
        'connection': IntegrationConnectionDtoToJSON(value['connection']),
    };
}
